var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1523 6.15234V63.8477C41.1523 67.2518 38.4044 70 35 70H6.15234C2.74791 70 0 67.2518 0 63.8477V6.15234C0 2.74791 2.74791 0 6.15234 0H35C38.4044 0 41.1523 2.74791 41.1523 6.15234Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1523 6.15234V63.8477C41.1523 67.2518 38.4044 70 35 70H20.6445V0H35C38.4044 0 41.1523 2.74791 41.1523 6.15234Z",
    fill: "#29376D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0508 6.15234V63.8477C37.0508 64.996 36.1486 65.8984 35 65.8984H6.15234C5.00377 65.8984 4.10156 64.996 4.10156 63.8477V6.15234C4.10156 5.00377 5.00377 4.10156 6.15234 4.10156H35C36.1486 4.10156 37.0508 5.00377 37.0508 6.15234Z",
    fill: "#6AA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0508 6.15234V63.8477C37.0508 64.996 36.1486 65.8984 35 65.8984H20.6445V4.10156H35C36.1486 4.10156 37.0508 5.00377 37.0508 6.15234Z",
    fill: "#4895FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6445 12.3047C21.7771 12.3047 22.6953 11.3865 22.6953 10.2539C22.6953 9.12129 21.7771 8.20312 20.6445 8.20312C19.5119 8.20312 18.5938 9.12129 18.5938 10.2539C18.5938 11.3865 19.5119 12.3047 20.6445 12.3047Z",
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 59.7461C24.7461 60.8944 23.8439 61.7969 22.6953 61.7969H18.5938C17.4452 61.7969 16.543 60.8944 16.543 59.7461C16.543 58.5975 17.4452 57.6953 18.5938 57.6953H22.6953C23.8439 57.6953 24.7461 58.5975 24.7461 59.7461Z",
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6445 12.3047V8.20312C21.7931 8.20312 22.6953 9.10533 22.6953 10.2539C22.6953 11.4022 21.7931 12.3047 20.6445 12.3047Z",
    fill: "#D5E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 59.7461C24.7461 60.8944 23.8439 61.7969 22.6953 61.7969H20.6445V57.6953H22.6953C23.8439 57.6953 24.7461 58.5975 24.7461 59.7461Z",
    fill: "#D5E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 24.7461V28.8477L65.8984 30.8984H28.8477L24.7461 28.8477V24.7461L28.8477 22.6953H65.8984L70 24.7461Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 24.7461V28.8477L65.8984 30.8984H47.3047V22.6953H65.8984L70 24.7461Z",
    fill: "#29376D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 28.8477V47.3047C70 48.453 69.0978 49.3555 67.9492 49.3555H26.7969C25.6483 49.3555 24.7461 48.453 24.7461 47.3047V28.8477H70Z",
    fill: "#FFDE46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 18.5938V24.7461H24.7461V18.5938C24.7461 17.4452 25.6483 16.543 26.7969 16.543H67.9492C69.0978 16.543 70 17.4452 70 18.5938Z",
    fill: "#FFDE46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 18.5938V24.7461H47.3047V16.543H67.9492C69.0978 16.543 70 17.4452 70 18.5938Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3047 28.8477H70V47.3047C70 48.453 69.0978 49.3555 67.9492 49.3555H47.3047V28.8477Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6094 37.0508H55.5078C54.3743 37.0508 53.457 36.1335 53.457 35C53.457 33.8665 54.3743 32.9492 55.5078 32.9492H59.6094C60.7429 32.9492 61.6602 33.8665 61.6602 35C61.6602 36.1335 60.7429 37.0508 59.6094 37.0508Z",
    fill: "#29376D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.c192f2ceaa8f2889c7c657770ad8d59b.svg";
export { ForwardRef as ReactComponent };